import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EdpTruncatePipe } from "./edp-truncate.pipe";
import { EdpDecimalSplitPipe } from "./edp-decimal-split.pipe";
import { EdpDotToCommaPipe } from "./edp-dot-to-comma.pipe";
import { EdpBoldSearchPipe } from "./edp-bold-search.pipe";
import { EdpCapitalizePipe } from "./edp-capitalize.pipe";
import { EdpTimerFormatPipe } from "./edp-timer-format.pipe";
import { EdpFilterHidePipe } from "./edp-filter-hide.pipe";

@NgModule({
    imports: [CommonModule],
    declarations: [
        EdpTruncatePipe,
        EdpDecimalSplitPipe,
        EdpDotToCommaPipe,
        EdpBoldSearchPipe,
        EdpCapitalizePipe,
        EdpTimerFormatPipe,
        EdpFilterHidePipe,
    ],
    entryComponents: [],
    exports: [
        EdpTruncatePipe,
        EdpDecimalSplitPipe,
        EdpDotToCommaPipe,
        EdpBoldSearchPipe,
        EdpCapitalizePipe,
        EdpTimerFormatPipe,
        EdpFilterHidePipe,
    ],
})
export class EdpPipesModule {}
